import { useAuthStore } from "~/store/auth";

export default defineNuxtRouteMiddleware((to, _from) => {
  const authStore = useAuthStore();

  if (
    to.path !== "/login" &&
    !to.path.startsWith("/public/") &&
    authStore.isLoggedIn === false
  ) {
    return navigateTo("/login");
  }
});
